<div *ngIf="isRetrievingUser; else elseBlock">
  <div nz-row nzSpan="24" nzJustify="center" nzAlign="middle">
    <div nz-col nzSpan="8">
      <nz-spin i18n-nzTip="Auth.Generic.SpinnerText|text in spinner@@Auth.Generic.SpinnerText" nzTip="Caricamento..."
        [nzSpinning]="isRetrievingUser"></nz-spin>
    </div>
  </div>
</div>
<ng-template #elseBlock>
  <nz-layout>
    <nz-sider id="side-identities">
      <div nz-row>
        <div id="back-dash" nz-col nzSpan="24" *ngIf="rightView != 'personalData'" style="margin-bottom: 1rem;">
          <a class="custom-form-forgot" (click)="onChooseAction('personalData')">
            <i nz-icon nzType="arrow-left" nzTheme="outline" style="margin-right: 0.5rem;"></i>
            <ng-container
              i18n="Identity.Identity.BackToDashboard|label for link to go to dashboard section@@Identity.Identity.BackToDashboard">
              Torna alla dashboard
            </ng-container>
          </a>
        </div>
        <div nz-col nzSpan="24">
          <h3 i18n="Identity.Identity.Title|title for identity section@@Identity.Identity.Title"
            style="margin-bottom: 1rem;font-weight: normal">Identità utente</h3>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="24">
          <app-identity-list [user]="currentUser" [identities]="currentUser?.identities">
          </app-identity-list>
        </div>
      </div>
      <div *ngFor="let identity of currentUser?.identities">
        <div *ngIf="canShowRequestButton()">
          <div nz-row nzJustify="center" *ngIf="rightView != 'requests'">
            <div nz-col nzSpan="24">
              <button class="homeButton" nz-button nzType="default" (click)="changeView('requests')">
                <i nz-icon nzType="solution" nzTheme="outline"></i>
                Richieste</button>
            </div>
          </div>
          <div nz-row nzJustify="center" *ngIf="rightView != 'draft'">
            <div nz-col nzSpan="24">
              <button class="homeButton" nz-button nzType="default" (click)="changeView('draft')">
                <i nz-icon nzType="profile" nzTheme="outline"></i>
                Bozze</button>
            </div>
          </div>
        </div>
      </div>
    </nz-sider>
    <nz-content [ngSwitch]="rightView">
      <app-personal-data *ngSwitchCase="'personalData'"></app-personal-data>
      <app-requests *ngSwitchCase="'requests'"></app-requests>
      <app-complete-request *ngSwitchCase="'completeRequest'"></app-complete-request>
      <app-draft *ngSwitchCase="'draft'"></app-draft>
      <app-compile-draft *ngSwitchCase="'compileDraft'"></app-compile-draft>
      <app-edit-identity *ngSwitchCase="'editIdentity'"></app-edit-identity>
      <app-edit-credentials *ngSwitchCase="'editCredentials'"></app-edit-credentials>
      <app-access-logs *ngSwitchCase="'accessLogs'"></app-access-logs>
      <app-suspend-identity *ngSwitchCase="'suspendIdentity'" [currentUser]="currentUser"></app-suspend-identity>
      <app-resume-identity *ngSwitchCase="'resumeIdentity'" [currentUser]="currentUser"></app-resume-identity>
      <app-revoke-identity *ngSwitchCase="'revokeIdentity'" [currentUser]="currentUser"></app-revoke-identity>
    </nz-content>
  </nz-layout>
</ng-template>


<nz-modal
  [nzVisible]="isQrCodeModalVisible$ | async"
  (nzVisibleChange)="onCloseQrCodeModal()"
  [nzTitle]="'Associa il tuo telefono'"
  [nzClosable]="false"
  [nzContent]="qrCodeTmpl"
  [nzFooter]="qrCodeButtonTmpl"
  nzClassName="qrCodeAssociationModal"
>
  <ng-template #qrCodeTmpl>
    <app-qr-code-association
      [description]="descriptionTmpl"
      (onSyncronizeWithApp)="onCloseQrCodeModal()"
    >
      <ng-template #descriptionTmpl>
        <div nz-row nzGutter="16">
          <div nz-col>
            <span nz-icon nzType="appstore-add" nzTheme="outline" class="text-xl"></span>
          </div>
          <div nz-col nzFlex="1">
            <p i18n="@@EditCredentials.QrCodeAssociation.Description.Paragraph.First" class="mb-16">
              Vai sullo Store del tuo telefono (IPhone o Android) e scarica l'app <b>"TSID abilitato SPID"</b>
            </p>
          </div>
        </div>
        <div nz-row nzGutter="16">
          <div nz-col>
            <span nz-icon nzType="qrcode" nzTheme="outline" class="text-xl"></span>
          </div>
          <div nz-col nzFlex="1">
            <p i18n="@@EditCredentials.QrCodeAssociation.Description.Paragraph.Second" class="mb-16">
              Segui le indicazioni sul telefono e quando rischiesto, scansiona il QR Code:
            </p>
          </div>
        </div>
      </ng-template>
    </app-qr-code-association>
  </ng-template>
  <ng-template #qrCodeButtonTmpl>
    <button nz-button (click)="onCloseQrCodeModal()"> Chiudi </button>
  </ng-template>
</nz-modal>
